import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
import { SubsWrapperSkeleton } from './SubsWrapper.skeleton';
const SubsWrapper = React.lazy(async () => await import('./SubsWrapper').then(({ SubsWrapper }) => ({ default: SubsWrapper })));
export const Subcollections = () => {
    const { handle = '' } = useParams();
    const { objects, loading } = useHierarchyContext();
    if (!loading &&
        (objects[handle] === undefined || objects[handle].children.length < 1)) {
        return null;
    }
    return (React.createElement(Suspense, { fallback: React.createElement(SubsWrapperSkeleton, { showTabs: objects[handle]?.subcollectionsAsTabs }) },
        React.createElement(SubsWrapper, null)));
};
